<template>
  <div class="login-wrapper">
    <div class="login">

      <div class="login__banner">
        <img src="@/assets/img/ic_onecampus.svg" alt="OneCampus Logo" width="120" height="120">
        <div>OneCampus</div>
      </div>

      <div class="login__form">
        <b-message size="is-small" v-if="$store.getters['auth/errorMessage']" type="is-danger">
          {{ $store.getters['auth/errorMessage'] }}
        </b-message>

        <form @submit.prevent="login">
          <b-field label="Username">
            <b-input v-model="username"></b-input>
          </b-field>
          <b-field label="Password">
            <b-input v-model="password" type="password" password-reveal></b-input>
          </b-field>

          <b-field label="Campus">
            <b-select placeholder="Select a campus" v-model="selectedCampusId">
              <option
                v-for="campus in campuses"
                :value="campus.campusId"
                :key="campus.campusId">
                {{ campus.name }}
              </option>
            </b-select>
          </b-field>

          <b-field class="m-t-md">
            <b-button class="button is-info" expanded
                      :disabled="$store.getters['auth/isLoading']"
                      native-type="submit">Login
            </b-button>
          </b-field>

        </form>
      </div>
    </div>
  </div>
</template>
<script>
import hashPassword from '@/plugins/hashPassword'
import callApi from '@/plugins/api/callApi'

export default {
  name: 'Login',
  data () {
    return {
      username: '',
      password: '',
      selectedCampusId: null,
      campuses: []
    }
  },
  mounted () {
    callApi('/campuses', 'get').then(response => {
      this.campuses = response.sort((a, b) => a.name.localeCompare(b.name))
    }).catch(error => {
      console.error('Error fetching campuses:', error)
    })
  },
  methods: {
    login (defaultRedirectRoute = '/') {
      this.$store.dispatch('auth/login', {
        username: this.username,
        password: hashPassword(this.password),
        campusId: this.selectedCampusId
      }).then(() => {
        if (this.$store.getters['auth/isAuthenticated']) {
          this.redirectWithDefaultRoute(defaultRedirectRoute)
        }
      })
    },
    redirectWithDefaultRoute (defaultRoute) {
      if (this.$route.query.nextUrl != null) {
        this.$router.push(this.$route.query.nextUrl)
      } else {
        this.$router.push(defaultRoute)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.login-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background: #f7f7f7;
}

.login {
  display: flex;
  justify-content: space-evenly;
  background-color: #fff;
  border-radius: 10px;

  &__banner {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    @apply bg-accent;
    color: #ffffff;
    font-size: 2.5em;
    text-align: center;
    width: 100%;
    padding: 5rem;
  }

  &__form {
    border-radius: 5px;
    padding: 3rem;

    &__header {
      text-align: center;
      margin-bottom: .75em;
    }

  }

}
</style>
